import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./CustomPhoneInput.css";
import Text from "../text/Text";
import Invalid from "./img/invalid.svg";

export default function CustomPhoneInput({
  value,
  onChange,
  label,
  width = "100%",
  error,
  errorMessage,
  disabled,
  required = false,
}) {
  const handlePhoneChange = (phone) => {
    if (!disabled) {
      onChange(phone);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: "4px", width }}
    >
      {label && (
        <div className="phone-input-label">
          <Text
            size="0.875rem"
            color="#344054"
            weight="500"
            align="left"
            text={
              required ? (
                <>
                  {label}
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </>
              ) : (
                label
              )
            }
          />
        </div>
      )}
      <div
        className={`phone-input-container ${
          error ? "phone-input-error-border" : ""
        } ${disabled ? "phone-input-disabled" : ""}`}
      >
        <PhoneInput
          international
          defaultCountry="MY"
          value={value}
          onChange={handlePhoneChange}
          countryCallingCodeEditable={false}
          placeholder="Enter phone number"
          className={`phone-input ${error ? "error" : ""} ${
            disabled ? "disabled" : ""
          }`}
          disabled={disabled}
        />
        {error && (
          <img src={Invalid} className="phone-input-error-icon" alt="Invalid" />
        )}
      </div>
      <p className={`phone-input-error-message ${error ? "visible" : ""}`}>
        {errorMessage || "Invalid phone number"}
      </p>
    </div>
  );
}
